"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schema = void 0;
var decorators_1 = require("../decorators");
var utils_1 = require("../utils");
var ASchema = /** @class */ (function () {
    function ASchema() {
    }
    return ASchema;
}());
// tslint:disable-next-line: max-classes-per-file
var Schema = /** @class */ (function (_super) {
    __extends(Schema, _super);
    function Schema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.message = "";
        _this.schemaConfig = {};
        _this.formatCallbacks = {};
        _this.validate = function (data, schema, name) {
            var outscopeTypes = [];
            var pass = false;
            try {
                if (utils_1.utils.isObject(schema)) {
                    // 验证指定数据schema
                    // 校验前先注册自定义数据类型
                    if (schema.dataType) {
                        Object.keys(schema.dataType).forEach(function (typeName) {
                            _this.addSchema(typeName, schema.dataType[typeName]);
                            outscopeTypes.push(typeName);
                        });
                    }
                    // 校验数据
                    _this.doValidate(data, schema, data, name || "Unknow", []);
                }
                else if (utils_1.utils.isString(schema)) {
                    // 验证指定规则name
                    _this.doValidate(data, _this.schemaConfig[schema], data, schema, []);
                }
                else {
                    var vname = Object.keys(_this.schemaConfig)[0];
                    _this.doValidate(data, _this.schemaConfig[vname], data, vname, []);
                }
                pass = true;
            }
            catch (e) {
                _this.message = e.message;
                console.error(e);
                pass = false;
            }
            finally {
                if (outscopeTypes.length > 0) {
                    outscopeTypes.forEach(function (key) {
                        delete _this.schemaConfig[key];
                    });
                }
                // tslint:disable-next-line: no-unsafe-finally
                return pass;
            }
        };
        return _this;
    }
    Schema.prototype.addSchema = function (name, schema) {
        if (schema) {
            this.schemaConfig[name] = schema;
        }
    };
    Schema.prototype.removeSchema = function (name) {
        if (this.schemaConfig && !utils_1.utils.isEmpty(name)) {
            delete this.schemaConfig[name];
        }
    };
    Schema.prototype.doValidate = function (data, schema, sourceData, name, prefixKey) {
        var _a, _b, _c;
        var properties = schema === null || schema === void 0 ? void 0 : schema.properties;
        if (properties) {
            for (var _i = 0, _d = Object.keys(properties); _i < _d.length; _i++) {
                var attrKey = _d[_i];
                var config = properties[attrKey];
                var isRequired = config.isRequired;
                var type = config === null || config === void 0 ? void 0 : config.type;
                var keyPathArray = __spreadArray(__spreadArray([], prefixKey), [attrKey]);
                var keyPath = __spreadArray(__spreadArray([], prefixKey), [attrKey]).join(".");
                var importRules = false;
                var checkValue = data[attrKey];
                if (!utils_1.utils.isEmpty(config.defaultValue) && (null === checkValue || undefined === checkValue)) {
                    checkValue = config.defaultValue;
                }
                if (!utils_1.utils.isEmpty(config.format)) {
                    if (typeof this.formatCallbacks[config.format] === "function") {
                        checkValue = this.formatCallbacks[config.format](checkValue, sourceData);
                    }
                }
                if (isRequired && data && (undefined === data[attrKey] || null === data[attrKey])) {
                    // data[attrKey] = config.default;
                    throw new Error("\u914D\u7F6E" + name + "\u6570\u636E\u5C5E\u6027" + keyPath + "\u662FisRequired\u5B57\u6BB5\u53C2\u6570\u4E0D\u80FD\u4E3A\u7A7A\u3002");
                }
                if (data) {
                    if (/^#/.test(type)) {
                        var schemaName = type.replace(/^#/, "");
                        if (this.schemaConfig[schemaName]) {
                            importRules = true;
                            this.doValidate(data[attrKey], this.schemaConfig[schemaName], sourceData, schemaName, keyPathArray);
                        }
                        else {
                            throw new Error("\u914D\u7F6E" + name + "\u53C2\u6570\u5C5E\u6027" + keyPath + "\u5F15\u7528\u89C4\u5219(" + schemaName + ")\u4E0D\u5B58\u5728");
                        }
                    }
                    else {
                        if (/Array\<[#a-zA-Z0-9]{1,}\>/.test(type)) {
                            this.checkArrayTypes(data[attrKey], type, keyPath, name, keyPathArray, sourceData);
                        }
                        else {
                            if (!this.checkType(data[attrKey], type, keyPath, name)) {
                                var typeDesc = utils_1.utils.isRegExp(type) ? type.source : JSON.stringify(type);
                                throw new Error("\u914D\u7F6E" + name + "\u6570\u636E\u5C5E\u6027" + keyPath + "\u6570\u636E\u7C7B\u578B\u4E0D\u6B63\u786E\uFF0C\u5B9A\u4E49\u7C7B\u578B\uFF1A" + typeDesc + ", \u914D\u7F6E\u6570\u636E\uFF1A" + JSON.stringify(data[attrKey]));
                            }
                            else {
                                if (config.length > 0) {
                                    if (((_a = data[attrKey]) === null || _a === void 0 ? void 0 : _a.length) !== config.length) {
                                        throw new Error("\u914D\u7F6E" + name + "\u6570\u636E\u5C5E\u6027" + keyPath + "\u6570\u636E\u957F\u5EA6\u5FC5\u987B\u662F" + config.length + "\u4F4D\u3002");
                                    }
                                }
                                else if (config.maxLength > 0) {
                                    if (((_b = data[attrKey]) === null || _b === void 0 ? void 0 : _b.length) > config.maxLength) {
                                        throw new Error("\u914D\u7F6E" + name + "\u6570\u636E\u5C5E\u6027" + keyPath + "\u6570\u636E\u957F\u5EA6\u4E0D\u80FD\u5927\u4E8E" + config.maxLength + "\u3002");
                                    }
                                }
                                else if (config.minLength > 0) {
                                    if (((_c = data[attrKey]) === null || _c === void 0 ? void 0 : _c.length) < config.minLength) {
                                        throw new Error("\u914D\u7F6E" + name + "\u6570\u636E\u5C5E\u6027" + keyPath + "\u6570\u636E\u957F\u5EA6\u5FC5\u987B\u5927\u4E8E" + config.minLength + "\u3002");
                                    }
                                }
                            }
                        }
                    }
                    !importRules && this.doValidate(data[attrKey], config, sourceData, name, keyPathArray);
                }
            }
        }
        return true;
    };
    Schema.prototype.checkArrayTypes = function (data, type, keyPath, name, prefixArray, sourceData) {
        var _a;
        var typeRegExp = /^Array\<([#0-9a-zA-Z]{1,})\>$/;
        var dataMatch = type.match(typeRegExp);
        var declareTypes = ((_a = this.schemaConfig[name]) === null || _a === void 0 ? void 0 : _a.declareTypes) || {};
        if (utils_1.utils.isArray(data)) {
            if (dataMatch) {
                var arrayItemType = dataMatch[1];
                if (/^[a-z]{1,}$/i.test(arrayItemType)) {
                    var index = 0;
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var dataItem = data_1[_i];
                        this.checkType(dataItem, arrayItemType, keyPath + "." + index, name);
                        index += 1;
                    }
                }
                else {
                    var useItemType = arrayItemType.replace(/^#/, "");
                    var useTypeSchema = declareTypes[useItemType] || this.schemaConfig[useItemType];
                    var index = 0;
                    if (useTypeSchema) {
                        for (var _b = 0, data_2 = data; _b < data_2.length; _b++) {
                            var dataItem = data_2[_b];
                            this.doValidate(dataItem, useTypeSchema, sourceData, name, __spreadArray(__spreadArray([], prefixArray), [index.toString()]));
                            index += 1;
                        }
                    }
                    else {
                        throw new Error("\u9A8C\u8BC1\u89C4\u5219\u4E0D\u5B58\u5728" + useItemType + ",\u8BF7\u68C0\u67E5\u8BBE\u7F6E\u3002" + keyPath);
                    }
                }
            }
            else {
                throw new Error("\u914D\u7F6E" + name + "\u5B9A\u4E49\u7C7B\u578B\u9519\u8BEF(" + keyPath + ")\u3002");
            }
        }
        else {
            if (/^Array\<[a-zA-Z0-9]{1,}\>$/.test(type)) {
                if (data && type.indexOf(data) < 0) {
                    throw new Error("\u914D\u7F6E" + name + "\u53C2\u6570" + keyPath + "\u6570\u636E\u7C7B\u578B\u9519\u8BEF\u5B9A\u4E49\u7C7B\u578B\uFF1A" + type + "\u3002[Aarry_I500]");
                }
            }
            else {
                throw new Error("\u914D\u7F6E" + name + "\u53C2\u6570" + keyPath + "\u6570\u636E\u7C7B\u578B\u9519\u8BEF\u5B9A\u4E49\u7C7B\u578B\uFF1A" + type + "\u3002[Aarry_D500]");
            }
        }
    };
    Schema.prototype.checkType = function (data, type, keyPath, name) {
        if (undefined === data || null === data) {
            return true;
        }
        else {
            if (utils_1.utils.isRegExp(type)) {
                return type.test(data);
            }
            else if (utils_1.utils.isArray(type)) {
                if (utils_1.utils.isArray(data)) {
                    // do the validate if the config data is an array
                    var pass = true;
                    for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
                        var item = data_3[_i];
                        if (type.indexOf(item) < 0) {
                            pass = false;
                            break;
                        }
                    }
                    return pass;
                }
                else {
                    return type.indexOf(data) >= 0;
                }
            }
            else if (utils_1.utils.isString(type)) {
                switch (type) {
                    case "String": {
                        return utils_1.utils.isString(data);
                    }
                    case "Object": {
                        return utils_1.utils.isObject(data);
                    }
                    case "Array": {
                        return utils_1.utils.isArray(data);
                    }
                    case "RegExp": {
                        return utils_1.utils.isRegExp(data);
                    }
                    case "Number": {
                        return utils_1.utils.isNumeric(data);
                    }
                    case "Boolean": {
                        return utils_1.utils.isBoolean(data);
                    }
                    default: {
                        if (/\|/.test(type)) {
                            var mutilTypes = type.split("|");
                            var isPass = false;
                            for (var _a = 0, mutilTypes_1 = mutilTypes; _a < mutilTypes_1.length; _a++) {
                                var signType = mutilTypes_1[_a];
                                try {
                                    this.checkType(data, signType, keyPath, name);
                                    isPass = true;
                                    break;
                                }
                                catch (e) {
                                    console.log(signType);
                                    console.error(e);
                                }
                            }
                            if (!isPass) {
                                throw new Error("\u914D\u7F6E" + name + "\u53C2\u6570" + keyPath + "\u6570\u636E\u7C7B\u578B\u9519\u8BEF\uFF1A" + type + ", \u5176\u4E2D\u4E00\u4E2A\u6570\u636E\u7C7B\u578B\u3002");
                            }
                            return true;
                        }
                        else {
                            throw new Error("\u914D\u7F6E" + name + "\u53C2\u6570" + keyPath + "\u6570\u636E\u7C7B\u578B\u9519\u8BEF\uFF1A" + type + ", [String, Object, Array, RegExp, Number]");
                        }
                    }
                }
            }
            else {
                throw new Error("\u914D\u7F6E" + name + "\u53C2\u6570" + keyPath + "\u6570\u636E\u7C7B\u578B\u9519\u8BEF\uFF1A" + type + ", [String, Object, Array, RegExp, Number]");
            }
        }
    };
    Schema = __decorate([
        decorators_1.Service
    ], Schema);
    return Schema;
}(ASchema));
exports.Schema = Schema;
